import { useQuery } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";
import {fetch as fetchComboValue} from "../settings/useComboValues";
import __ from "lodash";

const apiSitePrefix = getApiSitePrefix();

const augmentData = async (data, queryClient) => {
  const reasons = await fetchComboValue({queryClient, extraKeys: ['SERVICE CANCELLATION REASONS',''], useCache: true});
  const comboValues = await fetchComboValue({queryClient, extraKeys: ['SERVICE CANCELLATION ACTIONS',''], useCache: true});
  const augmentedData = await Promise.all(data.map(async (record) => {
    const canAmendOrder = ['ORIGIN', 'DESTINATION', 'DEPARTURE TIME', 'ARRIVAL TIME'].indexOf(`${record.reason}`) >=0;
    const recommendedActionCode = record.status === "REQUIRED" ?(canAmendOrder?'AMEND REQUIRED ORDER':'CANCEL REQUIREMENT'):canAmendOrder?'AMEND ORDER':'CANCEL ORDER';    
    const combo = __.find(comboValues, {code: recommendedActionCode});
    const reason = __.find(reasons, {code: record.reason});
    return {
      ...record, recommendedActionCode, recommendedActionText: combo?.value||recommendedActionCode, reasonText: reason?.value||''
    }
  }));
  return augmentedData;
}

const getData = async (tableRef, queryClient, key, extraKeys, useCache, callback) => {
  if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
    return queryClient.getQueryData(key);
  }
  if (useCache) {
    const cachedData = queryClient.getQueryData([...key, '_cached']);
    if (cachedData) {
      if (callback) {callback(cachedData, extraKeys)}
      return cachedData
    };
    const realData = queryClient.getQueryData(key);
    if (realData) {
      if (callback) {callback(realData, extraKeys)}
      return realData;
    }
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  const { data } = await axios.get(
    `${apiSitePrefix}/handlingorders/list/${extendedPath}`
  );
  if (callback) {callback(data, extraKeys)}
  return await augmentData(data, queryClient);
};

const buildKey = (props) => {
  let key = ['HandlingOrders'];
  if (props.extraKeys) {
    key = [
      ...key,
      ...props.extraKeys
    ]
  }
  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return {key, queryKey};
}

export default function useHandlingOrders(props) {    
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return useQuery(
    queryKey, 
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback), 
    options
  );
}

export {buildKey}